export default __webpack_public_path__ + "static/media/md-card-bg-CEH-V12.c365f8ac.png";